import React from "react";

import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  EmailShareButton,
  PocketShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  LinkedinIcon,
  PocketIcon,
  EmailIcon
} from "react-share";

const SharingWidget = ({ url, title }) => (
  <div className="d-flex justify-content-start py-3">
    <FacebookShareButton url={url} quote={title} className="mr-1">
      <FacebookIcon
        round={true}
        size={32}
        logoFillColor="white"
        iconBgStyle={{ fill: "black" }}
      />
    </FacebookShareButton>
    <TwitterShareButton
      url={url}
      via="labouragainstas"
      title={title}
      className="mx-1"
    >
      <TwitterIcon
        round={true}
        size={32}
        logoFillColor="white"
        iconBgStyle={{ fill: "black" }}
      />
    </TwitterShareButton>
    <EmailShareButton
      url={url}
      subject={title}
      body=""
      openWindow={true}
      className="mx-1"
    >
      <EmailIcon
        round={true}
        size={32}
        logoFillColor="white"
        iconBgStyle={{ fill: "black" }}
      />
    </EmailShareButton>
    <LinkedinShareButton url={url} className="mx-1">
      <LinkedinIcon
        round={true}
        size={32}
        logoFillColor="white"
        iconBgStyle={{ fill: "black" }}
      />
    </LinkedinShareButton>
    <WhatsappShareButton url={url} title={title} className="d-md-none mx-1">
      <WhatsappIcon
        round={true}
        size={32}
        logoFillColor="white"
        iconBgStyle={{ fill: "black" }}
      />
    </WhatsappShareButton>
    <PocketShareButton url={url} className="d-md-none mx-1">
      <PocketIcon
        round={true}
        size={32}
        logoFillColor="white"
        iconBgStyle={{ fill: "black" }}
      />
    </PocketShareButton>
  </div>
);

export default SharingWidget;
